import React from 'react'
import { ProductDetailInfo } from '../../interface'
import styles from './index.module.less'
// import Image from '@/client/commonCom/imge';
import { topRankIcons } from '../../config'
import Image from '@/base-components/image'

import Jockeys from '@/utils/jockey'
import { withReactTrack } from '@du/analytics-sdk'
import { createTrackConfig } from './track-config'
import { isInApp } from '@/utils'
import appInstall from '@/utils/appUtils/appInstall'
import Lazyload from 'react-lazyload'

const padNumStart = (num: number, limit?: number) => {
  return num.toString().padStart(limit || 2, '0')
}

const throttle = function (fn: (...data: any[]) => void, delay: number) {
  let timer = null

  return function () {
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn()
    }, delay)
  }
}

interface IProps extends ProductDetailInfo {
  showTopTip?: boolean
  price?: string
  priceShow?: string
  currency?: string
  commonProps: { pageId: string; CName: string; uid?: string }
}
@withReactTrack({ createTrackConfig })
class ProductInfo extends React.PureComponent<IProps> {
  constructor(props: IProps) {
    super(props)
    this.goProductDetailInNative = throttle(this.goProductDetail, 500)
  }
  private goProductDetailInNative: () => void

  private goProductDetail = () => {
    const { spuId } = this.props
    const url = '/sell/productDetail'
    if (isInApp) {
      Jockeys.openNativePage(url, { spuId })
    } else {
      appInstall(url, { spuId })
    }
  }

  render() {
    const { index, title, subTitle, currency, priceShow, logoUrl, showTopTip, spuId } = this.props

    const bgImg = index > 3 ? topRankIcons[4] : topRankIcons[index]

    return (
      <div className={styles.wrapperContainer}>
        <div>
          <div
            onClick={this.goProductDetailInNative}
            className={styles.wrapper}
            data-track-click="poizon_venue_component_content_click"
            data-track-exposure="poizon_venue_component_content_exposure"
          >
            <div className={styles.left}>
              <Lazyload height={80} offset={200}>
                <Image
                  src={logoUrl}
                  options={[
                    {
                      mode: 'resize',
                      width: 160,
                    },
                  ]}
                />
              </Lazyload>
              {showTopTip ? (
                <div className={styles.topTip} style={{ backgroundImage: `url(${bgImg})` }}>
                  <p>{padNumStart(index)}</p>
                </div>
              ) : null}
            </div>
            <div className={styles.right}>
              <div className={styles.title}>{title}</div>
              <div className={styles.subTitle}>{subTitle}</div>
              <div className={styles.placeholder}></div>
              <div className={styles.priceArea}>
                <div className={styles.currency}>
                  {currency} {priceShow}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProductInfo
